"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableCell = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../../utils/index.js");
/**
 * Editable cell.
 * It should be passed to `cellRenderer`.
 * @example
 * {
 *   Header: 'Name',
 *   accessor: 'name',
 *   cellRenderer: (props) => <EditableCell {...props} onCellEdit={onCellEditHandler} />,
 * }
 */
const EditableCell = (props) => {
    const { cellElementProps, cellProps, onCellEdit, children, isDisabled, ...rest } = props;
    isDisabled; // To omit and prevent eslint error.
    const sanitizeString = (text) => {
        return text.replace(/(\r\n|\n|\r)+/gm, ' ');
    };
    const [value, setValue] = React.useState(() => sanitizeString(cellProps.value));
    React.useEffect(() => {
        setValue(sanitizeString(cellProps.value));
    }, [cellProps.value]);
    const [key, setKey] = React.useState((0, index_js_1.getRandomValue)(10));
    const [isDirty, setIsDirty] = React.useState(false);
    return (React.createElement("div", { ...cellElementProps, contentEditable: true, suppressContentEditableWarning: true, key: key, ...rest, onInput: (e) => {
            var _a;
            setValue(sanitizeString(e.target.innerText));
            setIsDirty(true);
            (_a = props.onInput) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, onBlur: (e) => {
            var _a;
            if (isDirty) {
                onCellEdit(cellProps.column.id, value, cellProps.row.original);
            }
            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
            // Prevents error when text is cleared.
            // New key makes React to reattach with the DOM so it won't complain about deleted text node.
            setKey((0, index_js_1.getRandomValue)(10));
        }, onKeyDown: (e) => {
            var _a;
            // Prevents from adding HTML elements (div, br) inside a cell on Enter press
            if (e.key === 'Enter') {
                e.preventDefault();
            }
            (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, onPaste: (e) => {
            var _a;
            e.preventDefault();
            document.execCommand('inserttext', false, sanitizeString(e.clipboardData.getData('text/plain')));
            (_a = props.onPaste) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, onDrop: (e) => {
            var _a;
            // Prevents from drag'n'dropping into a cell because it will add unwanted HTML elements
            e.preventDefault();
            (_a = props.onDrop) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, onClick: (e) => {
            var _a;
            e.stopPropagation();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }, children));
};
exports.EditableCell = EditableCell;
exports.default = exports.EditableCell;
